import { render, staticRenderFns } from "./TextArea.vue?vue&type=template&id=14bec4ec&scoped=true&"
import script from "./TextArea.vue?vue&type=script&lang=ts&"
export * from "./TextArea.vue?vue&type=script&lang=ts&"
import style0 from "./TextArea.vue?vue&type=style&index=0&id=14bec4ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14bec4ec",
  null
  
)

export default component.exports